/* eslint-disable react-hooks/exhaustive-deps */
import LockIcon from "@mui/icons-material/Lock";
import Logout from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import SettingsIcon from "@mui/icons-material/Settings";
import { Avatar, Button, Divider, Grid, IconButton, ListItemIcon, Menu, MenuItem, TextField, Tooltip, Typography } from "@mui/material";
import { GridCard } from "components/atoms";
import { ECommonDialogType } from "components/molecules/CommonDialog";
import { DialogHelper } from "helpers";
import { IWarehouse } from "model";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { IdentityActions, LanguageActions, WarehouseActions } from "redux/actions";
import { useAppSelector } from "redux/configurations/reduxHooks";
import { RootReducer } from "redux/configurations/rootReducer";
import { theme } from "themes/theme";
import { ELanguage, I18nTranslator, _t, translations } from "utils/i18n";
import ChangePasswordModal from "./ChangePasswordModal";
import { LANGUAGES } from "./const";

interface IHeaderProps {
  handleDrawerToggle: () => void;
}

const MenuAccount = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [changePasswordModalVisible, setChangePasswordModalVisible] = React.useState<boolean>(false);
  const history = useHistory();

  const user = useSelector((state: RootReducer) => state.IdentityReducer.authenticate);
  const action = useSelector((state: RootReducer) => state.IdentityReducer.action);
  const { t } = useTranslation();
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const idToken = useAppSelector((state) => state.IdentityReducer.authenticate?.idToken) || "";
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handelLogout = () => {
    DialogHelper.open({
      type: ECommonDialogType.WARNING,
      title: "Đăng xuất",
      message: "Bạn có muốn đăng xuất khỏi hệ thống MSD WMS",
      isCancel: true,
      onConfirm: () => {
        dispatch(IdentityActions.logout.request());
      },
    });
  };

  useEffect(() => {
    if (action.includes(IdentityActions.changePassword.successName))
      DialogHelper.open({
        title: "Đổi mật khẩu thành công",
        message: "Vui lòng đăng nhập lại",
        onConfirm: () => {
          dispatch(IdentityActions.logout.request());
        },
      });
  }, [action]);
  return (
    <>
      <Tooltip title="Account settings">
        <IconButton onClick={handleClick} size="small" sx={{ ml: 2 }}>
          <Avatar sx={{ width: 32, height: 32 }}>{user?.userName.slice(0, 1).toUpperCase()}</Avatar>
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem sx={{ paddingBottom: "10px" }}>
          <Avatar /> {user?.userName}
        </MenuItem>
        <MenuItem onClick={() => setChangePasswordModalVisible(true)}>
          <ListItemIcon>
            <LockIcon fontSize="small" />
          </ListItemIcon>
          <Typography>{t(_t(translations.changePassword))}</Typography>
        </MenuItem>
        <MenuItem onClick={() => history.push("/setting")}>
          <ListItemIcon>
            <SettingsIcon fontSize="small" />
          </ListItemIcon>
          <Typography>{t(_t(translations.setting))}</Typography>
        </MenuItem>
        <Divider />
        <MenuItem onClick={handelLogout}>
          <ListItemIcon>
            <Logout color="error" fontSize="small" />
          </ListItemIcon>
          <Typography color={"error"}>{t(_t(translations.logout))}</Typography>
        </MenuItem>
      </Menu>
      <ChangePasswordModal open={changePasswordModalVisible} onClose={() => setChangePasswordModalVisible(false)} />
    </>
  );
};

const MenuLanguage = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const language = useSelector((state: RootReducer) => state.LanguageReducer.language);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const onChangeLanguage = (language: ELanguage) => {
    dispatch(LanguageActions.changeLanguage.request(language));
  };

  const renderLanguage = (lg: { key: ELanguage; name: string; icon: any }) => (
    <MenuItem
      key={lg.name}
      onClick={() => onChangeLanguage(lg.key)}
      style={{
        color: language === lg.key ? theme.palette.primary.main : undefined,
        paddingLeft: 32,
        paddingRight: 32,
      }}
    >
      <Avatar alt="vn" src={lg.icon} />
      <Typography>{lg.name}</Typography>
    </MenuItem>
  );

  return (
    <>
      <Tooltip title="Language settings">
        <Button startIcon={<Avatar sx={{ width: 32, height: 32 }} alt="vn" src={LANGUAGES.find((lg) => lg.key === language)?.icon} />} onClick={handleClick} size="small" sx={{ ml: 2 }}>
          {language?.toUpperCase()}
        </Button>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {LANGUAGES.map((lg) => {
          return renderLanguage(lg);
        })}
      </Menu>
    </>
  );
};

export const Header = (props: IHeaderProps) => {
  const dispatch = useDispatch();
  const warehouses = (useAppSelector((state) => state.IdentityReducer.authenticate?.warehouses) as IWarehouse[]) || [];
  const currentUser = useAppSelector((state) => state.IdentityReducer.authenticate);
  const currentWarehouse = useAppSelector((state) => state.IdentityReducer.currentWarehouse) as IWarehouse;
  const action = useAppSelector((state) => state.WarehouseReducer.action);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const warehouseId = event.target.value;

    const warehouseSelected = warehouses?.find((warehouse) => warehouse.id === warehouseId) as IWarehouse;
    dispatch(IdentityActions.setCurrentWarehouse.request(warehouseSelected));
  };

  useEffect(() => {
    if (action.includes(WarehouseActions.createWarehouse.successName) || action.includes(WarehouseActions.deleteWarehouse.successName)) {
      dispatch(
        IdentityActions.getAllWarehouses.request({
          userId: currentUser?.id,
          pageSize: 100,
          pageNumber: 1,
        })
      );
    }
  }, [action]);
  return (
    <GridCard
      sx={{
        zIndex: 999,
      }}
    >
      <Grid container spacing={2} sx={{ p: 2, pr: "8px", pl: "8px" }} alignItems="center">
        <Grid item container xs={11} sm={6}>
          <IconButton color="inherit" aria-label="open drawer" edge="start" onClick={props.handleDrawerToggle} sx={{ mr: 2, display: { sm: "none" } }}>
            <MenuIcon />
          </IconButton>
          <Grid item xs={12} lg={6}>
            <TextField id="outlined-select-warehouse" select onChange={handleChange} fullWidth label={I18nTranslator(translations.warehouse)} value={currentWarehouse?.id}>
              {warehouses.map((warehouse) => (
                <MenuItem key={warehouse.id} value={warehouse.id}>
                  {warehouse.description}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
        <Grid item container sx={{ display: { xs: "flex", sm: "none" } }} xs={1} justifyContent="flex-end">
          <MenuLanguage />
          <MenuAccount />
        </Grid>
        <Grid item container sx={{ display: { xs: "none", sm: "flex" } }} sm={6} justifyContent="flex-end">
          <MenuLanguage />
          <MenuAccount />
        </Grid>
      </Grid>
    </GridCard>
  );
};
